import logoPath from "@assets/Asset 1_1750308719655.png";

interface AppLoadingScreenProps {
  message?: string;
  showProgress?: boolean;
}

export function AppLoadingScreen({ message = "Loading...", showProgress = true }: AppLoadingScreenProps) {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50/30 flex items-center justify-center">
      <div className="text-center space-y-6">
        <div className="flex justify-center">
          <div className="relative">
            <img
              src={logoPath}
              alt="SaaSGama"
              className="h-16 w-auto object-contain"
            />
            {showProgress && (
              <div className="absolute inset-0 animate-pulse opacity-60">
                <img
                  src={logoPath}
                  alt="SaaSGama"
                  className="h-16 w-auto object-contain"
                />
              </div>
            )}
          </div>
        </div>
        
        <div className="space-y-2">
          <p className="text-slate-600 font-medium">{message}</p>
        </div>
        
        {showProgress && (
          <div className="flex justify-center">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
          </div>
        )}
      </div>
    </div>
  );
}